<template>
    <modal @close="closeFromModal">
        <template #header>
            <h5>Détails de la réservation</h5>
        </template>
        <template #body>
            <invalid-reservation :reservation="reservation" />
        </template>
        <template #footer>
            <div class="d-flex w-100 justify-content-between">
                <button class="modal-default-button btn-sm btn btn-secondary btn-circle" @click="close">Fermer</button>
            </div>
        </template>
    </modal>
</template>

<script>
import InvalidReservation from "../../reservations/InvalidReservation.vue";

export default {
    props: {
        reservation: {
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        InvalidReservation,
    },
};
</script>
